import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { collection, getDoc, updateDoc, doc, getCountFromServer } from 'firebase/firestore';
import db from '../firebase';
import { SpinnerContext } from '../contexts/SpinnerContext';

export const MetadataContext = createContext();

export const MetadataProvider = ({ children, user }) => {
    const [metadata, setMetadata] = useState({});
    const [totalArticleCount, setTotalArticleCount] = useState(0);
    const { showSpinner, hideSpinner } = useContext(SpinnerContext);

    useEffect(() => {
        const fetchTotalArticleCount = async () => {
            if (!user) return; // Ensure user is available before fetching articles
            //showSpinner('Loading metadata...');

            try {
                const articlesCollection = collection(db, 'articles');
                const snapshot = await getCountFromServer(articlesCollection);
                setTotalArticleCount(snapshot.data().count);
            } catch (error) {
                console.error('Error fetching total article count:', error);
            }
            //hideSpinner();
        };

        fetchTotalArticleCount();
    }, [user]);

    const updateMetadata = useCallback(async (updatedData) => {
        //showSpinner('Updating metadata...');
        try {
            showSpinner('Updating metadata...');
            await updateDoc(doc(db, 'metadata', 'metadataDocumentId'), updatedData);
            setMetadata(prevMetadata => ({
                ...prevMetadata,
                ...updatedData
            }));
            //hideSpinner();
        } catch (error) {
            console.error("Error updating metadata: ", error);
            throw error; // Propagate error to caller
        }
     finally {
        hideSpinner();
    }
    },[showSpinner, hideSpinner]);


    useEffect(() => {
        const fetchMetadata = async () => {
            if (!user) return; // Ensure user is available before fetching articles
            //showSpinner('Loading metadata...');
            try {
                const metadataDoc = await getDoc(doc(db, 'metadata', 'metadataDocumentId'));
                if (metadataDoc.exists()) {
                    setMetadata(metadataDoc.data());
                } else {
                    console.error("No such document!");
                }
            } catch (error) {
                console.error("Error fetching metadata: ", error);
            }
            //hideSpinner();
        };

        fetchMetadata();
        
    }, [user, updateMetadata]);


    return (
        <MetadataContext.Provider value={{ metadata, updateMetadata, totalArticleCount, setMetadata }}>
            {children}
        </MetadataContext.Provider>
    );
};